import {
  WEATHER_SCHEDULE_INTERVALS,
  getWeatherPipelineHealth,
  getWeatherPipelineSources,
  runWeatherPipelineSource,
  updateWeatherPipelineSource,
} from "./midpointApi";

export { pollWeatherRefreshUntilComplete } from "./pollWeatherRefreshUntilComplete.js";

export { WEATHER_SCHEDULE_INTERVALS };

export async function fetchWeatherSources() {
  return getWeatherPipelineSources();
}

export async function runWeatherSource(sourceCode) {
  return runWeatherPipelineSource(sourceCode);
}

export async function updateWeatherSource(sourceCode, payload) {
  const response = await updateWeatherPipelineSource(sourceCode, payload);
  return response.source || response;
}

export async function fetchWeatherSourceHealth(sourceCode, filters = {}) {
  return getWeatherPipelineHealth(sourceCode, filters);
}

export function schedulePayloadFromInterval(minutes, scheduleEnabled) {
  if (!scheduleEnabled || minutes == null) {
    return {
      scheduleEnabled: false,
      scheduleIntervalMinutes: null,
    };
  }

  return {
    scheduleEnabled: true,
    scheduleIntervalMinutes: minutes,
  };
}

export function intervalMinutesFromSource(source) {
  if (!source?.scheduleEnabled) {
    return null;
  }

  return source.scheduleIntervalMinutes ?? null;
}
